import {useCallback, useEffect, useState} from 'react';
import {Button, Checkbox, FormControlLabel, makeStyles, TextField} from "@material-ui/core";
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {DatePicker, KeyboardTimePicker, MuiPickersUtilsProvider,} from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';
import CreatorBtn from "../../../../atoms/creator/experienceBuilderEnterBtn";
import {useDispatch, useSelector} from "react-redux";
import {moveNextPage, updateUserMetrics} from "../../../../../store/actions/creator/creatorExperienceBuilder";
import UtilService from "../../../../../helper/service";
import moment from "moment";
import CustomSnackBar from '../../experienceManager/participantsDashboard/component/CustomSnackBar';
import clsx from "clsx";
import {useHistory, useLocation} from "react-router";

const useStyles = makeStyles(() => ({
  label: {
    "&$focusedLabel": {
      color: "#707070"
    },
    "&$erroredLabel": {
      color: "#707070"
    }
  },
  focusedLabel: {
    fontSize: 14,
    fontFamily: 'roboto-black',
  },
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#8F99A3'
  },
  normal: {
    color: '#8F99A3',
    "&:before": {
      borderBottom: `1px solid rgba(0, 0, 0, 0.42)`
    },
    "&:after": {
      borderBottom: `1px solid rgba(0, 0, 0, 0.42)`
    }
  },
  error: {
    color: '#f44336',
    "&:before": {
      borderBottom: `1px solid #f44336`
    },
    "&:after": {
      borderBottom: `1px solid #f44336`
    }
  },
  calendarBtnLabel: {
    fontSize: 16,
    fontFamily: 'roboto-regular',
    textTransform: 'none'
  },
  errorMessage: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#707070'
  },
  clockIcon: {
    width: '18px',
    height: '18px',
    cursor: 'pointer',
    background: 'white'
  },
  errMsg: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#f44336',
    marginTop: '5px',
    "&:before": {
      borderBottom: `1px solid #f44336`
    },
    "&:after": {
      borderBottom: `1px solid #f44336`
    }
  },
  checkbox: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  checkBoxLabel: {
    color: '#212D40',
    fontFamily: 'roboto-regular',
    fontSize: 14
  },
  checkedLabel: {
    fontWeight: 'bold'
  },
  timeDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  timePickerInput: {
    width: '160px!important',
    '& > div': {
      fontSize: 14,
      fontFamily: 'roboto-regular',
      color: '#8F99A3'
    },
    '& input': {
      display: 'flex',
      alignItems: 'center'
    }
  },
  timezoneStart: {
    '& input#timezoneStart::before': {
      content: (props: any) => props.start ? `"${props.start}"`: "''",
      marginLeft: 74,
      position: 'absolute'
    },
  },
  timezoneEnd: {
    '& input#timezoneEnd::before': {
      content: (props: any) => props.end ? `"${props.end}"`: "''",
      marginLeft: 74,
      position: 'absolute'
    },
  }
}));

const PreRecordedSchedule = () => {
  const {userMetrics, page, globalSaveSetting, prevPage} = useSelector((state: any) => state.creatorExperienceBuilder);
  const {asyncStartDateTime, asyncEndDateTime, streamType, startNow, asyncLastActivePage, createReel} = userMetrics;

  const classes = useStyles({
    start: UtilService.getTimeZoneDate(asyncStartDateTime) !== 'Invalid date' ? UtilService.getTimeZoneDate(asyncStartDateTime) : '', 
    end: UtilService.getTimeZoneDate(asyncEndDateTime) !== 'Invalid date' ? UtilService.getTimeZoneDate(asyncEndDateTime) : '', 
  });
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const [isShownSnackAlert, setShownSnackAlert] = useState(false);
  const [validStartDate, setValidStartDate] = useState(0);
  const [validStartTime, setValidStartTime] = useState(0);
  const [validEndDate, setValidEndDate] = useState(0);
  const [validEndTime, setValidEndTime] = useState(0);

  const invalidStartDateMsg = ["", "Start Date must be later than current Date & Time"];
  const invalidStartTimeMsg = ["", "Start Time must be later than current Date & Time", 'Invalid Time Format'];
  const invalidEndDateMsg = ["", "End Date must be later than Start Date & Time", "Duration must be longer than 5 minutes"];
  const invalidEndTimeMsg = ["", "End Time must be later than Start Date & Time", "", 'Invalid Time Format'];

  const handleUserKeyPress = (event: any) => {
    if (
      event.keyCode === 13 && asyncStartDateTime && validStartDate === 0 && validStartTime === 0
      && validEndDate === 0 && validEndTime === 0
    ) {
      goNext();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  useEffect(() => {
    if (history.location.hash !== '#schedule') {
      UtilService.addHashTag(history, location.pathname, 'schedule');
    }
  }, []);

  useEffect(() => {
    if (asyncStartDateTime.getTime() < new Date().getTime()) {
      const startDate = UtilService.getStartDateTime();
      dispatch(updateUserMetrics('asyncStartDateTime', startDate));
      prevPage < 3 && dispatch(updateUserMetrics('asyncEndDateTime', UtilService.getXHoursAboveDateTime(startDate, 24)))
    }
    checkValidation();
  }, [dispatch]);

  useEffect(() => {
    const endDateTime = UtilService.getXHoursAboveDateTime(asyncStartDateTime, 24);
    prevPage < 3 && dispatch(updateUserMetrics('asyncEndDateTime', endDateTime));
    checkValidation();
  }, [asyncStartDateTime]);

  useEffect(() => {
    checkValidation();
  }, [asyncEndDateTime]);

  const goNext = () => {
    const nextPage = createReel ? page + 1 : (globalSaveSetting ? page + 2 : page + 1);
    dispatch(moveNextPage(nextPage));
    (asyncLastActivePage < nextPage) && dispatch(updateUserMetrics('asyncLastActivePage', nextPage));
  };

  const checkValidation = useCallback(() => {

    let ved = 0;
    let vet = 0;
    let vsd = 0;
    let vst = 0;

    const now = new Date();
    const date1 = new Date(asyncStartDateTime.getTime());
    date1.setHours(0,0,0,0);

    const date2 = new Date(asyncEndDateTime.getTime());
    date2.setHours(0,0,0,0);

    ved = (date2 >= date1) ? 0 : 1;
    vet = asyncStartDateTime.getTime() < asyncEndDateTime.getTime() ? 0 : 1;

    if (asyncStartDateTime.getTime() < now.getTime()) {
      const date1 = new Date(asyncStartDateTime.getTime());
      date1.setHours(0,0,0,0);

      const date2 = new Date(now.getTime());
      date2.setHours(0,0,0,0);

      if (vsd === 0)
        vsd = (date1 > date2) ? 0 : 1;   // Start Date should be after now.
      if (vst === 0)
        vst = (date1 !== date2) ? 0 : 1;  // Start Time should be after now.
    }

    if ((asyncEndDateTime.getTime() - asyncStartDateTime.getTime()) < 5 * 60 * 1000) {
      if (ved === 0 && vet === 0)
        ved = 2;
      if (vet === 0)
        vet = 2;
    }

    setValidStartDate(vsd);
    setValidStartTime(vst);
    setValidEndDate(ved);
    setValidEndTime(vet);
  }, [asyncStartDateTime, asyncEndDateTime]);

  const cancelBtn = () => {
    return (
      <Button variant="contained" className={classes.calendarBtnLabel}>
        Cancel
      </Button>
    )
  };

  const okBtn = () => {
    return (
      <Button variant="contained" color='primary' className={classes.calendarBtnLabel}>
        OK
      </Button>
    )
  };

  const hideSnackAlert = () => {
    setShownSnackAlert(false);
  }

  const onStartNow = (isStartNow: boolean) => {
    dispatch(updateUserMetrics('startNow', isStartNow));
    const currentTime = new Date();
    const updatedTime = new Date(currentTime.getTime() + 60 * 1000);
    dispatch(updateUserMetrics('asyncStartDateTime', updatedTime));
  };

  const handleStartDateChange = (startDate: Date) => {
    dispatch(updateUserMetrics('asyncStartDateTime', startDate));
  };

  const handleStartTimeChange = (startTime: Date) => {
    dispatch(updateUserMetrics('asyncStartDateTime', startTime));
  };

  const handleEndDateChange = (endDate: Date) => {
    dispatch(updateUserMetrics('asyncEndDateTime', endDate));
  };

  const handleEndTimeChange = (endTime: Date) => {
    dispatch(updateUserMetrics('asyncEndDateTime', endTime));
  };

  const getStartTimeStr = useCallback(() => {
    const time = UtilService.getLocalTime(asyncStartDateTime);  
    const hour = time.getHours();
    const minute = time.getMinutes();
    return `${hour >=10 ? hour : `0${hour}`}:${minute >= 10 ? minute : `0${minute}`}`
  }, [asyncStartDateTime]);

  const onChangeStartTime = (e: any) => {
    const timeStr = e.target.value;
    if (timeStr) {
      const hoursAndMinutes = timeStr.split(':');
      const hours = Number(hoursAndMinutes[0]);
      const minutes = Number(hoursAndMinutes[1]);
      const time = UtilService.getLocalTime(asyncStartDateTime);
      const updatedTime = time.setHours(hours, minutes);
      dispatch(updateUserMetrics('asyncStartDateTime', UtilService.getLocalTimeReverse(new Date(updatedTime))));
    }
  };

  const getEndTimeStr = useCallback(() => {
    const time = UtilService.getLocalTime(asyncEndDateTime);
    const hour = time.getHours();
    const minute = time.getMinutes();
    return `${hour >=10 ? hour : `0${hour}`}:${minute >= 10 ? minute : `0${minute}`}`
  }, [asyncEndDateTime]);

  const onChangeEndTime = (e: any) => {
    const timeStr = e.target.value;
    if (timeStr) {
      const hoursAndMinutes = timeStr.split(':');
      const hours = Number(hoursAndMinutes[0]);
      const minutes = Number(hoursAndMinutes[1]);
      const time = UtilService.getLocalTime(asyncEndDateTime);
      const updatedTime = time.setHours(hours, minutes);
      dispatch(updateUserMetrics('asyncEndDateTime', UtilService.getLocalTimeReverse(new Date(updatedTime))));
    }
  };

  return (
    <div>
      <p className='creator-main-title mt-65'>
        When do participants need to watch?
      </p>
      <div className='creator-main-panel'>
        <div style={{ textAlign: 'left' }}>
          <p className="creator-description">
            Give us the date and time range for capturing the measurements. Participants will be given this date as a deadline. You can adjust this at any time.
          </p>
        </div>
        <p className="creator-subtitle">
          Start
        </p>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid className={classes.timeDiv}>
            <DatePicker
              value={UtilService.getLocalTime(asyncStartDateTime)}
              onChange={(startDate: any) => handleStartDateChange(UtilService.getLocalTimeReverse(startDate))}
              animateYearScrolling
              format="MMMM dd, yyyy"
              cancelLabel={cancelBtn()}
              okLabel={okBtn()}
              minDate={UtilService.getLocalTime(new Date())}
              disabled={ startNow }
              error={validStartTime !== 0}
              InputLabelProps={{
                classes: {
                  root: clsx(classes.label, validStartDate === 0 ? classes.normal : classes.error),
                  focused: classes.focusedLabel,
                  error: classes.erroredLabel
                },
              }}
              InputProps={{
                classes: {
                  root: clsx(classes.underline, validStartDate === 0 ? classes.normal : classes.error),
                  error: classes.error
                },
                value: moment(UtilService.getLocalTime(asyncStartDateTime)).format('MMMM DD, yyyy')
              }}
            />
            &nbsp;&nbsp;&nbsp;
            <TextField
              type="time"
              value={getStartTimeStr()}
              className={classes.timePickerInput}
              disabled={ startNow }
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{
                step: 300, // 5 min,
              }}
              onChange={onChangeStartTime}
              id='timezoneStart'
              InputProps={{
                className: classes.timezoneStart,
              }}
            />
            <KeyboardTimePicker
              id="start-time-picker"
              value={UtilService.getLocalTime(asyncStartDateTime)}
              disabled={ startNow }
              cancelLabel={cancelBtn()}
              okLabel={okBtn()}
              error={validStartTime !== 0}
              onChange={(startTime: any) => handleStartTimeChange(UtilService.getLocalTimeReverse(startTime))}
              KeyboardButtonProps={{
                'aria-label': 'change time',
              }}
              style={{ width: 0, marginLeft: '-40px' }}
              keyboardIcon={
                <img
                  className={classes.clockIcon}
                  src={`/assets/icons/experiencebuilder/${startNow ? 'disabled-clock' : 'clock'}.svg`}
                  alt={'Clock'}
                />
              }
              InputLabelProps={{
                classes: {
                  root: clsx(classes.label, validStartTime === 0 ? classes.normal : classes.error),
                  focused: classes.focusedLabel,
                  error: classes.erroredLabel
                }
              }}
              InputProps={{
                classes: {
                  root: clsx(classes.underline, validStartTime === 0 ? classes.normal : classes.error),
                  error: classes.error
                }
              }}
            />

          </Grid>
          <div className={classes.errMsg}>{ invalidStartDateMsg[validStartDate] }</div>
          <div className={classes.errMsg}>{ invalidStartTimeMsg[validStartTime] }</div>
          <FormControlLabel
            control={
              <Checkbox
                className={classes.checkbox}
                checked={startNow}
                onChange={(e) => onStartNow(e.target.checked)}
                name="start_now"
                color="default"
              />
            }
            label={
              <span className={clsx(classes.checkBoxLabel, startNow && classes.checkedLabel)}>
                Start Now
              </span>
            }
          />
        </MuiPickersUtilsProvider>
        {
          streamType === 'VDO' &&
          <span className={classes.errorMessage}>
            The video must be fully processed before the experience may start.  This will occur automatically and we will send you a notification if there is any delay past your scheduled start time.
          </span>
        }

        <p className="creator-subtitle" style={{marginTop: 40}}>
          <span>End</span>
        </p>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid className={classes.timeDiv}>
            <DatePicker
              value={UtilService.getLocalTime(asyncEndDateTime)}
              onChange={(endDate: any) => handleEndDateChange(UtilService.getLocalTimeReverse(endDate))}              
              animateYearScrolling
              format="MMMM dd, yyyy"
              cancelLabel={cancelBtn()}
              okLabel={okBtn()}
              minDate={UtilService.getLocalTime(asyncStartDateTime)}
              error={validEndDate !== 0}
              InputLabelProps={{
                classes: {
                  root: classes.label,
                  focused: classes.focusedLabel,
                  error: classes.erroredLabel
                },
              }}
              InputProps={{
                classes: {
                  root: clsx(classes.underline, validEndDate === 0 ? classes.normal : classes.error),
                  error: classes.error
                },
                value: moment(UtilService.getLocalTime(asyncEndDateTime)).format('MMMM DD, yyyy'),
              }}
            />
            &nbsp;&nbsp;&nbsp;
            <TextField
              type="time"
              value={getEndTimeStr()}
              className={classes.timePickerInput}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 300, // 5 min
              }}
              onChange={onChangeEndTime}
              id='timezoneEnd'
              InputProps={{
                className: classes.timezoneEnd,
              }}
            />
            <KeyboardTimePicker
              id="end-time-picker"
              value={UtilService.getLocalTime(asyncEndDateTime)}
              cancelLabel={cancelBtn()}
              okLabel={okBtn()}
              error={validEndTime !== 0}
              onChange={(endTime: any) => handleEndTimeChange(UtilService.getLocalTimeReverse(endTime))}
              KeyboardButtonProps={{
                'aria-label': 'change time',
              }}
              style={{ width: 0, marginLeft: '-40px' }}
              keyboardIcon={
                <img
                  className={classes.clockIcon}
                  src={'/assets/icons/experiencebuilder/clock.svg'}
                  alt={'Clock'}
                />
              }
              InputLabelProps={{
                classes: {
                  root: clsx(classes.label, validEndTime === 0 ? classes.normal : classes.error),
                  focused: classes.focusedLabel,
                  error: classes.erroredLabel
                }
              }}
              InputProps={{
                classes: {
                  root: clsx(classes.underline, validEndTime === 0 ? classes.normal : classes.error),
                  error: classes.error
                }
              }}
            />

          </Grid>
          <div className={classes.errMsg}>{ invalidEndDateMsg[validEndDate] }</div>
          <div className={classes.errMsg}>{ invalidEndTimeMsg[validEndTime] }</div>
        </MuiPickersUtilsProvider>
      </div>
      {asyncStartDateTime && <CreatorBtn
        isValidation={true}
        isEnabled={validStartDate === 0 && validStartTime === 0 && validEndDate === 0 && validEndTime === 0}
        goNext={goNext}
      />}
      <CustomSnackBar type={"warning"} message={''} open={isShownSnackAlert} onClose={hideSnackAlert} />
    </div>
  )
}

export default PreRecordedSchedule;